"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.integralFormEnum = void 0;
//积分形式
var integralFormEnum = exports.integralFormEnum = [{
  label: '全员发放',
  value: 1
}, {
  label: '全员回收',
  value: 2
}, {
  label: '指定员工发放',
  value: 3
}, {
  label: '指定员工回收',
  value: 4
}];